import { useEffect, useState } from 'react';
import { useShop } from '../app/boot.tsx';
import { useShopPaths } from '../app/nav.tsx';
import { fieldErrors, message } from '../lib/errors.ts';
import { defaultPrivacyNotice } from '../customer/Privacy.tsx';
import { Button, Field, Loading, Page, useToast } from '../ui/index.tsx';

export function ShopInfo() {
  const { api, shop } = useShop();
  const { go } = useShopPaths();
  const toast = useToast();
  const [form, setForm] = useState<Record<string, string> | null>(null);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.staff.settings().then((a) => setForm({
      name: a.info.name, phone: a.info.phone ?? '', address: a.info.address ?? '', mapUrl: a.info.mapUrl ?? '', privacyNotice: a.info.privacyNotice ?? '',
    })).catch((e) => toast(message(e), 'error'));
  }, [api, toast]);

  if (!form) return <Page title="ข้อมูลร้าน" back={() => go('/staff/manage')}><Loading /></Page>;
  const set = (k: string, v: string) => setForm((f) => ({ ...(f as Record<string, string>), [k]: v }));

  async function save() {
    setErrors({});
    setBusy(true);
    try {
      await api.staff.updateShopInfo(form as Record<string, string>);
      toast('บันทึกแล้ว (มีผลเมื่อเปิดหน้าใหม่)', 'success');
    } catch (e) {
      const f = fieldErrors(e);
      if (Object.keys(f).length) setErrors(f);
      else toast(message(e), 'error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Page title="ข้อมูลร้าน" back={() => go('/staff/manage')}>
      <Field label="ชื่อร้าน" error={errors.name}><input value={form.name} onChange={(e) => set('name', e.target.value)} maxLength={80} /></Field>
      <Field label="เบอร์โทรร้าน" error={errors.phone}><input value={form.phone} onChange={(e) => set('phone', e.target.value)} inputMode="tel" /></Field>
      <Field label="ที่อยู่" error={errors.address}><textarea value={form.address} onChange={(e) => set('address', e.target.value)} maxLength={300} /></Field>
      <Field label="ลิงก์ Google Maps" error={errors.mapUrl} hint="เปิด Google Maps → แชร์ → คัดลอกลิงก์"><input value={form.mapUrl} onChange={(e) => set('mapUrl', e.target.value)} inputMode="url" /></Field>
      <Field label="นโยบายความเป็นส่วนตัว" error={errors.privacyNotice} hint="เว้นว่างเพื่อใช้ข้อความมาตรฐาน (ควรให้ผู้รู้กฎหมายตรวจสอบ)">
        <textarea value={form.privacyNotice} onChange={(e) => set('privacyNotice', e.target.value)} placeholder={defaultPrivacyNotice(shop.name)} rows={8} />
      </Field>
      <Button block loading={busy} onClick={() => void save()}>บันทึก</Button>
    </Page>
  );
}
